var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKidneyCardE5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 164,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 158,
    height: 158,
    rx: 12,
    fill: "#fff",
    stroke: "#652D86",
    strokeWidth: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.05 98.383c-16.654-7.111-10.082-31.116 1.48-35.081 4.797-1.645 10.088 3.813 10.055 7.201-.015 1.465-.762 2.895-1.54 4.383-1.021 1.956-2.098 4.012-1.64 6.391.804 4.19 1.706 11.261-.617 14.617-2.323 3.357-4.657 3.804-7.737 2.49zM98.47 63.302c11.561 3.965 18.135 27.97 1.479 35.081-3.08 1.316-5.415.868-7.737-2.49-2.323-3.355-1.422-10.426-.617-14.616.457-2.38-.62-4.437-1.64-6.391-.779-1.488-1.525-2.918-1.54-4.383-.033-3.388 5.259-8.846 10.054-7.201zM89.687 86.01l.107 1.546h.018l.005-.001a1.937 1.937 0 0 0-.257.056c-.26.074-.505.193-.726.35-.444.32-1.097 1.031-1.097 2.825v8.68a1.533 1.533 0 1 1-3.066 0v-8.68c0-2.74 1.088-4.418 2.383-5.354a5.412 5.412 0 0 1 2.239-.936c.081-.013.163-.023.245-.031l.025-.003h.016c0-.002.004-.002.108 1.547zM75.313 86.01c-.104 1.546-.106 1.546-.107 1.546h-.019l-.004-.001.036.004c.34.063.663.2.946.401.445.321 1.098 1.032 1.098 2.826v8.68a1.533 1.533 0 1 0 3.066 0v-8.68c0-2.74-1.088-4.418-2.385-5.354a5.408 5.408 0 0 0-2.239-.936 3.743 3.743 0 0 0-.245-.031l-.023-.003h-.017c0-.002-.001-.002-.107 1.547z",
    fill: "#744747"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKidneyCardE5);
export default __webpack_public_path__ + "static/media/kidneyCardE5.705c12a0.svg";
export { ForwardRef as ReactComponent };